<template>
  <v-container fluid>
    <v-layout>
      <v-flex md3>
        <v-container>
          <v-card>
            <v-card-title class="headline">KM Posts</v-card-title>
            <v-card-text class="scrolling-wrapper">
              <v-container fluid>
                <v-form ref="postForm">
                  <v-radio-group v-model="selectedPost" @click="changePost" column>
                    <v-radio v-for="(post, v) in data" :key="v" :value="post.value" color="red">
                      <template v-slot:label>
                        <div>
                          {{ post.text }}
                          <v-icon v-if="post.value.plot" color="red">place</v-icon>
                        </div>
                      </template>
                    </v-radio>
                    <!-- 
                  <v-radio
                    v-for="(post, v) in data"
                    :key="v"
                    color="primary"
                    :label="post.text"
                    :value="post.value"
                    ></v-radio>-->
                  </v-radio-group>
                </v-form>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>
      </v-flex>
      <v-flex>
        <div>
          <official-map
            :center="center"
            :zoom="zoom"
            ref="map"
            v-bind:style="{height: heightMap + 'vh', width: 'auto'}"
            v-on:currentCenter="currentCenter"
            v-on:placeName="placeName"
          ></official-map>
        </div>
      </v-flex>

      <v-flex v-if="post" md3 style="position: absolute; top: 11%; right: 3%;">
        <v-card>
          <v-container fluid class="py-1 my-0">
            <v-layout>
              <v-flex>
                <v-form ref="placeForm">
                  <v-text-field id="searchPlace" v-model="autocomplete" append-icon="search"></v-text-field>
                </v-form>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-text-field v-model="post.lat" label="Latitude" readonly></v-text-field>
            </v-layout>

            <v-layout>
              <v-text-field v-model="post.lng" label="Longitude" readonly></v-text-field>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-slider
                  v-model="radius"
                  label="Radius (m)"
                  thumb-label="always"
                  :max="2000"
                  :min="100"
                ></v-slider>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import OfficialMap from "@/components/OfficialMap";

export default {
  components: {
    OfficialMap
  },
  props: {
    data: {
      type: Array
    },
    center: {
      type: Object
    },
    zoom: {
      type: Number
    },
    postSelected: {
      type: Object
    }
  },
  data() {
    return {
      heightMap: 0,
      post: null,
      autocomplete: null,
      defaultRadius: 200
    };
  },
  computed: {
    selectedPost: {
      get() {
        return this.postSelected;
      },
      async set(val) {
        this.post = val;
        if (val) this.defaultRadius = val.radius;
      }
    },
    radius: {
      get() {
        return this.defaultRadius;
      },
      async set(val) {
        this.defaultRadius = val;

        this.$emit("setRadius", this.post, val);

        this.$refs.map.changeCircleRadius(val);
      }
    }
  },
  methods: {
    async initMap() {
      this.post = null;
      this.selectedPost = null;

      this.heightMap = 78;

      await this.$refs.map.initializeMap();

      await this.$refs.map.plotPosts(
        this.data.map(item => {
          return item.value;
        })
      );
    },
    async changePost() {
      await this.$refs.map.setPost(this.post);
      if (this.post) {
        this.$refs.placeForm.reset();
        await this.$refs.map.autoComplete();
      }

      this.$emit("selectPost", this.post);
    },
    currentCenter(data) {
      if (this.post) {
        this.$emit("setLocation", this.post, data);
      }
    },
    placeName(data) {
      this.autocomplete = data;
    },
    clear() {
      this.$refs.map.clear();
      this.post = null;
      this.selectedPost = null;

      // this.$refs.postForm.reset();
    }
  }
};
</script>

<style scoped>
.scrolling-wrapper {
  overflow-x: hidden;
  height: 650px;
  overflow-y: scroll;
  white-space: nowrap;
}
</style>